import {
  useCourseCompletionReports,
  useUserAwarenessReports,
} from '@/hooks/query';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import {
  getOverdueUsersCard,
  getTrainingCompletionCard,
  getTrainingContentCard,
  getUserCompletionCard,
} from '@/utils/helpers/awareness-key-results.helper';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { KeyResultCard } from './KeyResultCard';

const StyledKeyResultsGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: var(--medium-padding);
  width: 100%;

  @media screen and (max-width: 799px) {
    grid-template-columns: 1fr;
  }
`;

export const AwarenessKeyResults: React.FC<{ isMainDashboard?: boolean }> = ({
  isMainDashboard,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);

  const { courseCompletionReports, isLoading: courseCompletionLoading } =
    useCourseCompletionReports({
      accountId: currentAccount?.id,
    });

  const { userAwarenessReports, isLoading: userAwarenessLoading } =
    useUserAwarenessReports({
      accountId: currentAccount?.id,
    });

  const isLoading = courseCompletionLoading || userAwarenessLoading;

  const cards = [
    getTrainingCompletionCard(courseCompletionReports, t),
    getTrainingContentCard(courseCompletionReports, t),
    getUserCompletionCard(userAwarenessReports, t),
    getOverdueUsersCard(userAwarenessReports, t),
  ];

  return (
    <StyledKeyResultsGrid className={isMainDashboard ? 'mt-4' : 'mb-4'}>
      {cards.map((card) => (
        <KeyResultCard key={card.chartId} {...card} isLoading={isLoading} />
      ))}
    </StyledKeyResultsGrid>
  );
};
